import { mapActions } from 'vuex'

export default {
  data() {
    return {
      modalShow: false,
      show: true,
      selectedMessage: '',
      selectedMessageId: null,
      currentPage: 1,
      pageSize: 10,
    }
  },

  computed: {
    messagesFields() {
      return [
        { key: 'title', label: this.$t('title') },
        { key: 'subtitle', label: this.$t('subtitle') },
        { key: 'message', label: this.$t('Message') },
        { key: 'create_at', label: this.$t('create_at') },
      ]
    },
    messages() {
      return this.$store.state.Messaging.messages
    },
    totalMessages() {
      return this.$store.state.Messaging.totalMessages
    },
    selectedMessageModal() {
      return this.$store.state.Messaging.selectedMessage
    },
    unReadMessages() {
      return this.$store.state.Messaging.unReadMessages
    },
  },

  watch: {
    currentPage() {
      this.getAllMessages()
    },

    selectedMessageModal: {
      handler() {
        this.getAllMessages()
      },
      deep: true,
    },

    unReadMessages: {
      handler() {
        this.getAllMessages()
      },
      deep: true,
    },
  },

  async created() {
    await this.getAllMessages()
  },

  methods: {
    ...mapActions('Messaging', ['openMessageModal', 'setAllMessages']),
    async onRowSelected({ id }) {
      this.openMessageModal(id)
    },

    rowClass(item, type) {
      if (item && type === 'row') {
        if (!item.is_read) {
          return 'un-read-message'
        }
      }
      return null
    },

    async getAllMessages() {
      this.show = true
      await this.setAllMessages(
        {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        },
      )
      this.show = false
    },

    handleOk() {
      this.modalShow = false
      this.getAllMessages()
    },
  },
}
